import React from 'react'
import PropTypes from 'prop-types'
import { Link, graphql } from 'gatsby'
import Layout from '../components/layout'
import ReactMarkdown from "react-markdown"
import { css } from "@emotion/core"
import { max } from "../components/style/Base"
import Color from "../components/style/Color"
import Size from "../components/style/Size"

const indexArticle = css`
  img{
    display: none;
  }
  font-size:${Size.textS};
  line-height:1.4;
  color:${Color.Black};
  margin-top:8px;
`

const ul = css `
  display:flex;
  justify-content:space-between;
  flex-wrap:wrap;
`

const li = css`
  width:50%;
  padding:30px 20px;
  list-style:none;
  ${max[1]}{
    width:100%;
  }
`
const title = css`
  font-size:28px;
  font-weight:bold;
  line-height:1.4;
  a{
    color:${Color.Black};
    text-decoration: none;
  }
`

const contentImage = css`
  width:100%;
  max-width:100%;
  height:204px
`

const moreText = css`
  font-size:${Size.textS}
  color:${Color.MainColor};
  text-decoration: none;
  display:inline-block;
  margin-top:8px;
`


const IndexPage = ({ data }) => (
  <Layout>
    <ul css={ul}>
      {data.allStrapiArticle.edges.map(document => (
        <li key={document.node.id} css={li}>
          <img
            css={contentImage}
            src={`${process.env.IMAGE_BASE_URL}${document.node.image && document.node.image[0].url}`}
            alt={document.node.image && document.node.image[0].name}
          />
{console.log(document.node.image)}
          <h2 css={title}>
            <Link to={`/${document.node.id}`}>{document.node.title}</Link>
          </h2>
          <ReactMarkdown
            source={document.node.content.substring(0, 40).concat("...")}
            transformImageUri={uri => uri.startsWith('http') ? uri : `${process.env.IMAGE_BASE_URL}$`}
            css={indexArticle}
          />
          <Link to={`/${document.node.id}`} css={moreText}>続きを読む</Link>
        </li>
      ))}
    </ul>
  </Layout>
)

export default IndexPage

export const pageQuery = graphql`
  query IndexQuery {
    allStrapiArticle {
      edges {
        node {
          id
          title
          content
          image {
            name
            url
          }
        }
      }
    }
  }
`

IndexPage.propTypes = {
  data: PropTypes.object.isRequired
}
